import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from '../base.api.service';
import { ApiService } from '../../api.service';
import { ClinicEnvironmentService } from '../../../clinic-environment.service';

@Injectable({
  providedIn: 'root',
})
export class SettingAuthSatuSehatApiService implements ApiService<{ dateMake: string }> {
  constructor(
    private clinicEnvService: ClinicEnvironmentService,
    private baseApiService: BaseApiService
  ) {}

  private readonly _serviceType = 'settings-service/v1';

  public getAll(): Observable<{ dateMake: string }> {
    return this.baseApiService
      .get({
        serviceType: this._serviceType,
        endpoint: `cache/clinics/${this.clinicEnvService.clinicUuid}/auth-satusehat`,
      })
      .pipe(
        map((data) => {
          if (!data || !data?.authSatusehat) return null;
          return data.authSatusehat[0];
        })
      );
  }
}
